import React from "react";
import styles from "./upload.module.css";

type Props = {
  onSelect: (files: FileList | null) => void;
}

const Upload: React.FC<Props> = props => (
  <label className={styles.label}>
    <input onChange={event => props.onSelect(event.target.files)} type="file" accept=".csv" />
  </label>
);

export default Upload;
